<template>
  <div class="detail-bg">
    <div class="detail-title" v-if="from == 1">
      <img src="@/assets/reserve/success_icon.png" />
      <div>预约成功</div>
    </div>
    <div class="resever-detail">
      <div class="resever-box">
        <van-row class="mb-40 ">
          <van-col span="24" style="color: #333;" class="ft-40 fw-blod" align="middle"
          >预约号</van-col
          >
          <van-col span="24" style="color:#c88e60" class=" ft-64 fw-blod mt-20 " align="middle">{{
              info.reserveNo
            }}</van-col>
          <van-col span="24"  class="pb-20 ft-64 mt-20 "  align="middle">
            <div id="qrcode"></div>
          </van-col>
          <van-col span="24"  class="pb-40 ft-24  mt-20"  align="middle">
            取号时请将二维码对准扫码口
          </van-col>
          <van-col v-if="info.reserveNo" span="24" style="color: #ee0a24;animation:itemOpacity 5s infinite;" class="pb-40 ft-40 b-b;"  align="middle">
            为避免预约信息丢失，此页面请截图保存!
          </van-col>
        </van-row>
        <div class="ft-30 mb-30 c-66" style="display:flex;">
          <span class="user-label">业务名称</span>：<span class="c-black">{{ info.bizName }}</span>
        </div>
        <div class="ft-30 mb-30 c-66">
          <span class="user-label">姓名</span>：<span class="c-black">{{ info.clientName }}</span>
        </div>
        <div class="ft-30 mb-30 c-66">
          <span class="user-label">身份证号</span>：<span class="c-black">{{ info.clientIdnum }}</span>
        </div>
        <div class="ft-30 mb-30 c-66">
          <span class="user-label">手机号码</span>：<span class="c-black">{{ info.clientMobile }}</span>
        </div>
        <div class="ft-30  mb-30 c-66 pb-40 b-b">
          <span class="user-label">预约时段</span>：<span class=" fw-blod">{{ info.reserveTime }}</span>
        </div>
        <div class="ft-30 c-black mb-30 fw-blod">{{ info.netName }}</div>
        <div class="flex align-center mb-20">
          <img
              src="@/assets/reserve/address_icon.png"
              class="mr-15 address_icon"
          />
          <div class="c-66 ft-24">{{ info.address }}</div>
        </div>
        <div class="flex align-center mb-60">
          <img src="@/assets/reserve/phone_icon.png" class="mr-15 phone_icon" />
          <a :href="`tel:${info.tel}`" class="c-66 ft-24">{{ info.tel }}</a>
        </div>


        <!--        <div class="text-center">
                  <img src="@/assets/reserve/code.jpg" class="code" />
                  <div class="pb-40 ft-24 c-66">长按二维码关注公众号</div>
                </div> -->
      </div>
    </div>
    <div class="white-btn" @click="bindBackOne()" v-if="from == 2">返回</div>
    <div class="white-btn" @click="bindBack()" v-else>返回预约首页</div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2';
import { reserveDetail } from "@/api/index";
export default {
  data() {
    return {
      id: "",
      from: "", // 1-取号或预约成功，2-查看详情
      info: {},
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.from = this.$route.query.from;
    this.init();

  },
  mounted() {
    document.title = this.from == 1 ? "预约成功" : "预约详情";
  },
  methods: {
    init() {
      reserveDetail(this.id).then((res) => {
        this.info = res.data;
        // new QRCode(document.getElementById("qrcode"), "http://jindo.dev.naver.com/collie");
        var qrcode = new QRCode("qrcode", {
          text: res.data.reserveNo,
          width: 128,
          height: 128,
          colorDark : "#000000",
          colorLight : "#ffffff",
          correctLevel : QRCode.CorrectLevel.H
        });
      });
    },
    bindBack() {
      this.$router.push({ path: "service" });
    },
    bindBackOne() {
      this.$router.back();
    },
  },
};
</script>
<style>

@keyframes itemOpacity {
  0% {
    opacity: 1;
  }
  10% {
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  30% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}
</style>
<style lang="scss" scoped>
.detail-bg {
  min-height: 100%;
  background-color: $blue;
  padding-bottom: 100px;
}
.detail-title {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 40px 10px;
  font-size: 36px;
  color: #fff;
  font-weight: bolder;
  img {
    width: 40px;
    height: 40px;
    margin-right: 20px;
  }
}
.resever-detail {
  background: url("../../../../assets/reserve/success_bg.png") no-repeat;
  width: 100%;
  background-size: 100% 100%;
  margin: 0 auto;
  .user-label{
    text-align: justify;
    display: inline-block;
    width: 120px;
    text-align-last: justify;
    word-break: keep-all;
  }
  .resever-box {
    padding: 90px 60px 60px;
  }
  .phone_icon {
    width: 17px;
    height: 19px;
  }
  .address_icon {
    width: 16px;
    height: 22px;
  }
  .code {
    width: 260px;
    height: 260px;
    margin-bottom: 20px;
  }
}
.white-btn {
  height: 88px;
  font-size: 36px;
  border-radius: 16px;
  color: $blue;
  background-color: #fff;
  width: 93%;
  margin: 40px auto 0;
  text-align: center;
  line-height: 88px;
}

</style>
